import ErrorNotification from 'components/common/ErrorNotification';
import { GlobalModalProvider } from 'components/common/GlobalModal/GlobalModalContext';
import LoadingIndicator from 'components/common/LoadingIndicator';
import { PrivateRoute } from 'components/common/PrivateRoute';
import { AppLayout } from 'components/layout';
import ja from 'date-fns/locale/ja';
import LoginPage from 'features/Auth/pages/LoginPage';
import { registerLocale } from 'react-datepicker';
import { Route, Switch } from 'react-router-dom';
import './App.scss';

// register local ja for calendar component
registerLocale('ja', ja);

function App() {
  return (
    <div className="app">
      <GlobalModalProvider>
        <ErrorNotification />
        <Switch>
          <Route exact path="/login">
            <LoginPage />
          </Route>
          <Route path="/">
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          </Route>
        </Switch>
      </GlobalModalProvider>
      <LoadingIndicator />
    </div>
  );
}

export default App;
